import { useEffect } from 'react';

const useClickOutside = (ref: any, callback: any) => {
  const handleClick = (e: any) => {
    if (ref && ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [ref]);
};

export default useClickOutside;
